/* tslint:disable */
/* eslint-disable */
/**
 * Torrents Stream Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
    ProviderErrorModel,
    ProviderErrorModelFromJSON,
    ProviderErrorModelFromJSONTyped,
    ProviderErrorModelToJSON,
    ProviderModel,
    ProviderModelFromJSON,
    ProviderModelFromJSONTyped,
    ProviderModelToJSON,
} from './'

/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     *
     * @type {Array<ProviderModel>}
     * @memberof InlineResponse200
     */
    items: Array<ProviderModel>
    /**
     *
     * @type {Array<ProviderErrorModel>}
     * @memberof InlineResponse200
     */
    errors: Array<ProviderErrorModel>
}

export function InlineResponse200FromJSON(json: any): InlineResponse200 {
    return InlineResponse200FromJSONTyped(json, false)
}

export function InlineResponse200FromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): InlineResponse200 {
    if (json === undefined || json === null) {
        return json
    }
    return {
        items: (json['items'] as Array<any>).map(ProviderModelFromJSON),
        errors: (json['errors'] as Array<any>).map(ProviderErrorModelFromJSON),
    }
}

export function InlineResponse200ToJSON(value?: InlineResponse200 | null): any {
    if (value === undefined) {
        return undefined
    }
    if (value === null) {
        return null
    }
    return {
        items: (value.items as Array<any>).map(ProviderModelToJSON),
        errors: (value.errors as Array<any>).map(ProviderErrorModelToJSON),
    }
}
